import { createAction, props } from '@ngrx/store';
import { BusinessInformationEntity, BusinessSearchFilters } from 'src/app/models/business.model';

export const loadBusinessesByZipCode = createAction(
  '[Business] Load Businesses By ZipCode',
  props<{ zipCode: string }>()
);

export const loadBusinessesByZipCodeSuccess = createAction(
  '[Business] Load Businesses By ZipCode Success',
  props<{ 
    businesses: BusinessInformationEntity[]; 
    lastDocumentId: string | null; 
    hasMore: boolean;
    totalCount?: number;
    totalPages?: number;
    currentPage?: number;
    latitude?: number;
    longitude?: number;
  }>()
);

export const loadBusinessesByZipCodeFailure = createAction(
  '[Business] Load Businesses By ZipCode Failure',
  props<{ error: string }>()
);

export const searchBusinesses = createAction(
  '[Business] Search Businesses',
  props<{ filters: BusinessSearchFilters }>()
);

export const searchBusinessesSuccess = createAction(
  '[Business] Search Businesses Success',
  props<{ businesses: BusinessInformationEntity[] }>()
);

export const searchBusinessesFailure = createAction(
  '[Business] Search Businesses Failure',
  props<{ error: string }>()
);

export const loadMoreBusinesses = createAction(
  '[Business] Load More Businesses',
  props<{ zipCode: string; lastDocumentId: string | null }>()
);

export const loadMoreBusinessesSuccess = createAction(
  '[Business] Load More Businesses Success',
  props<{ businesses: BusinessInformationEntity[]; lastDocumentId: string | null; hasMore: boolean }>()
);

export const loadMoreBusinessesFailure = createAction(
  '[Business] Load More Businesses Failure',
  props<{ error: string }>()
);

export const loadMoreBusinessesByLocation = createAction(
  '[Business] Load More Businesses By Location',
  props<{ latitude: number; longitude: number; lastDocumentId: string | null; limit?: number }>()
);

export const clearBusinesses = createAction('[Business] Clear Businesses');

export const loadBusinessesByLocation = createAction(
  '[Business] Load Businesses By Location',
  props<{ latitude: number; longitude: number; limit?: number }>()
);

export const loadBusinessesByLocationSuccess = createAction(
  '[Business] Load Businesses By Location Success',
  props<{ businesses: BusinessInformationEntity[]; lastDocumentId: string | null; hasMore: boolean }>()
);

export const loadBusinessesByLocationFailure = createAction(
  '[Business] Load Businesses By Location Failure',
  props<{ error: string }>()
);

export const loadBusinessesByLocationPage = createAction(
  '[Business] Load Businesses By Location Page',
  props<{ latitude: number; longitude: number; page: number; lastDocumentId: string | null; limit?: number }>()
);

export const loadBusinessesByLocationPageSuccess = createAction(
  '[Business] Load Businesses By Location Page Success',
  props<{ businesses: BusinessInformationEntity[]; lastDocumentId: string | null; hasMore: boolean; page: number }>()
);

export const loadBusinessesByLocationPageFailure = createAction(
  '[Business] Load Businesses By Location Page Failure',
  props<{ error: string; page: number }>()
);

export const loadBusinessesByLocationPaginated = createAction(
  '[Business] Load Businesses By Location Paginated',
  props<{ latitude: number; longitude: number; pageNumber: number; limit: number; storeType?: string | null }>()
);

export const loadBusinessesByLocationPaginatedSuccess = createAction(
  '[Business] Load Businesses By Location Paginated Success',
  props<{ 
    businesses: BusinessInformationEntity[]; 
    totalCount: number; 
    totalPages: number; 
    currentPage: number; 
    hasMore: boolean;
    latitude?: number;
    longitude?: number;
  }>()
);

export const loadBusinessesByLocationPaginatedFailure = createAction(
  '[Business] Load Businesses By Location Paginated Failure',
  props<{ error: string }>()
);

